// extracted by mini-css-extract-plugin
export default {"PrimaryInput":"PrimaryInput_PrimaryInput__K6xd7"};